module.exports = __webpack_public_path__ + "media/luxury-2026/waterfront-living-d81a7486.jpg";